import noop from 'lodash/noop';
import React, {
  PropsWithChildren,
  ReactNode,
  useCallback,
  useContext,
  useState
} from 'react';

export const NotificationContext = React.createContext<{
  id?: string;
  message?: string | ReactNode;
  setId: (id?: string) => void;
  setMessage: (message: string | ReactNode) => void;
  onClose: () => void;
}>({
  setId: noop,
  setMessage: noop,
  onClose: noop
});

export const NotificationProvider: React.FC<PropsWithChildren> = ({
  children
}) => {
  const [id, setId] = useState<string | undefined>();
  const [message, setMessage] = useState<string | ReactNode | undefined>();

  const handleId = useCallback((notifId?: string) => setId(notifId), []);
  const handleMessage = useCallback(
    (NotifMessage: any) => setMessage(NotifMessage),
    []
  );
  const handleClose = async () => {
    if (id) {
      const dayjs = (await import('dayjs')).default;
      const timeStampString = dayjs().valueOf().toString();

      localStorage.setItem(`hide_${id}`, timeStampString);
      setId(undefined);
    }
  };

  return (
    <NotificationContext.Provider
      value={{
        id,
        message,
        setId: handleId,
        setMessage: handleMessage,
        onClose: handleClose
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
